export default __webpack_public_path__ + "static/media/step-2@3x.89826271.png";